import { IComponentOptions, IController } from "angular";
import { GtmhubController } from "@gtmhub/core";
import { IModalComponent } from "@gtmhub/core/routing";
import { localize } from "@gtmhub/localization";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ConfirmDeleteCtrl extends IModalComponent<{ localizationKey: string }> {}
export class ConfirmDeleteCtrl extends GtmhubController implements IController {
  translatedText: string;

  $onInit(): void {
    this.translatedText = localize(this.resolve.localizationKey);
  }
}

export const ConfirmDeleteComponent: IComponentOptions = {
  controller: ConfirmDeleteCtrl,
  templateUrl: require("./confirm-delete.jade"),
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
};
